// extracted by mini-css-extract-plugin
export default {"about_wrapper":"about_about_wrapper__B6Tsu","overlay":"about_overlay__FJvk5"};